import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useAccount = () =>
  useQuery({ queryKey: ["account"], queryFn: async () => (await api.get("/account/me")).data });
